export default __webpack_public_path__ + "static/media/unihr_logo.db608b64.png";